import React from 'react';
import {Redirect, Route, Switch} from 'react-router-dom';
import {IonApp, IonRouterOutlet} from '@ionic/react';
import {IonReactRouter} from '@ionic/react-router';
import Login from "./components/Login";
import Home from "./components/Home";
import Dashboard from './pages/dashboard/dashboard';
import ClinicianDashboard from './pages/clinician/ClinicianDashboard';
import ForgotPassword from './components/ForgotPassword';
import "./App.css"
import {AppContextProvider} from './components/AppContext';
import { UseAppDataProvider } from './context/appContext';
import { HelpProvider } from './context/HelpContext';
import { ThemeProvider } from './components/ThemeProvider';
import ErrorBoundary from './components/ErrorBoundary';
import {useMemo, useState, useEffect} from 'react';
import { DTAL} from './service/DTAL';
import SessionInvalidationService from './service/SessionInvalidationService';

const App = () => {

    const [appData, setAppData] = useState({count: 0, refreshToken: "", accessToken: ""});
    const [userData, setUserData] = useState({userId: "", userName: "", userType: "", emailId: "", sites: [], activeSiteId: ""});
    const [refreshTimerId, setRefreshTimerId] = useState({timerId: null});
    const [pageData, setPageData] = useState({formId: ""});
    const [userFilterData, setUserFilterData] = useState({userFilters:[], userFilterExpression:''});
    const [deviceFilterData, setDeviceFilterData] = useState({deviceFilters:[], deviceFilterExpression:''});
    const [userRecords, setUserRecords] = useState([]);
    const [deviceRecords, setDeviceRecords] = useState([]);
    const [dtalService, setDtalService] = useState(new DTAL(null));

    // Initialize session invalidation service on app load
    useEffect(() => {
      SessionInvalidationService.init();
      return () => {
        SessionInvalidationService.cleanup();
      };
    }, []);

    const appDataValue = useMemo(
        () => ({
            appData, refreshTimerId, userData, pageData, userFilterData,deviceFilterData, userRecords, deviceRecords, dtalService,
            setAppData, setRefreshTimerId, setUserData, setPageData, setUserFilterData, setDeviceFilterData, setUserRecords, setDeviceRecords, setDtalService
        }),
        [appData, refreshTimerId, userData, pageData, userFilterData, deviceFilterData, userRecords, deviceRecords, dtalService,
            setAppData, setRefreshTimerId, setUserData, setPageData, setUserFilterData, setDeviceFilterData, setUserRecords, setDeviceRecords,setDtalService]);

    return (
        <IonApp>
            <ErrorBoundary>
                <ThemeProvider>
                    <IonReactRouter>
                        <HelpProvider>
                            <UseAppDataProvider>
                                <AppContextProvider value={appDataValue}>
                                    <IonRouterOutlet id="mainContent">
                                    <Switch>
                                        <Route exact path="/login">
                                            <Login/>
                                        </Route>
                                        <Route exact path="/home/*">
                                            <Home/>
                                        </Route>
                                        <Route exact path="/forgotPassword">
                                            <ForgotPassword/>
                                        </Route>
                                        <Route exact path="/dashboard/*">
                                            <Dashboard/>
                                        </Route>
                                        <Route exact path="/clinician">
                                            <ClinicianDashboard/>
                                        </Route>
                                        <Route exact path="/">
                                            <Redirect to="/login"/>
                                        </Route>
                                    </Switch>
                                    </IonRouterOutlet>
                                </AppContextProvider>
                            </UseAppDataProvider>
                        </HelpProvider>
                    </IonReactRouter>
                </ThemeProvider>
            </ErrorBoundary>
        </IonApp>
    );
};
export default App;
